module.exports = __webpack_public_path__ + "img/meet-present.12fda778.png";